import type { SeoLink } from '@rover/rsdk/src/apiClient/latest/model/seoLink';
import type { SeoLocation } from '@rover/rsdk/src/apiClient/latest/model/seoLocation';

export default function getTopNeighborhoodServices(seoLocation: SeoLocation): SeoLink[] {
  return seoLocation.topNeighborhoodServices;
}
